"use client";

import React, { createContext, RefObject, useCallback, useContext, useEffect, useState } from "react";

export interface JumpMenuAnchor {
  id: string;
  name: string;
  inView: boolean;
  position: number;
}

type Props = {
  children: React.ReactNode;
};

interface JumpMenuContextType {
  anchorIdStates: JumpMenuAnchor[];
  updateAnchor: (anchorId: string, status: boolean) => void;
  addAnchor: (id: string, name: string, position: number) => void;
  removeAnchor: (id: string) => void;
}

export const JumpMenuContext = createContext<JumpMenuContextType>({} as JumpMenuContextType);

const JumpMenuProvider = ({ children }: Props) => {
  const [anchorIdStates, setAnchorIdStates] = useState<JumpMenuAnchor[]>([]);

  const updateAnchor = useCallback((id: string, status: boolean): void => {
    setAnchorIdStates((prev) =>
      prev.map((anchor) => {
        if (anchor.id === id) return { ...anchor, inView: status };
        return anchor;
      })
    );
  }, []);

  const addAnchor = useCallback((id: string, name: string, position: number) => {
    setAnchorIdStates((prev) => [
      ...prev,
      {
        name,
        id,
        inView: false,
        position,
      },
    ]);
  }, []);

  const removeAnchor = useCallback((id: string) => {
    setAnchorIdStates((prev) => prev.filter((a) => a.id !== id));
  }, []);

  const values = {
    anchorIdStates,
    updateAnchor,
    addAnchor,
    removeAnchor,
  };

  return <JumpMenuContext.Provider value={values}>{children}</JumpMenuContext.Provider>;
};

export default JumpMenuProvider;
